
/**
 * 2019-04-14
 * handan
 * 处理错误函数
 */
import { message } from "antd";
const handleError = (res)=>{
  console.log(res.msg);
  // alert("无效的请求，请稍后重试！");
  // alert(res.msg);
  message.warning(res.msg,2)
  return Promise.reject(res.msg);
}

export default handleError;